const KEYS = {
  Set: 'setItem',
  Remove: 'removeItem',
  ClearAll: 'clearAll',
  Clear: 'clear'
}

const now = () => ((new Date()).getTime() / 1000 | 0)

export default {
  namespaced: true,
  state: {
    cache_objects: []
  },
  mutations: {
    [KEYS.Set](state, obj) {
      state.cache_objects.tryRemove(obj, (other, me) => me.key === other.key)
      state.cache_objects.push(obj)
    },

    [KEYS.Remove](state, key) {
      state.cache_objects.tryRemove({ key }, (other, me) => me.key === other.key)
    },

    [KEYS.Clear](state, pattern) {
      var reserved = [...state.cache_objects]

      for (var i = reserved.length - 1; i >= 0; i--) {
        if (reserved[i].key.startsWith(pattern)) {
          reserved.splice(i, 1)
        }
      }

      state.cache_objects = reserved
    },

    [KEYS.ClearAll](state) {
      state.cache_objects = []
    }
  },
  actions: {
    set({ commit }, newObj) {
      if (newObj == null) {
        return
      }

      var key = newObj.key
      var value = newObj.value
      var seconds = newObj.seconds

      if (key == null || key === '') {
        throw new Error('cache key is required')
      }

      if (value == null) {
        commit(KEYS.Remove, key)
        return
      }

      if (seconds === 0) {
        seconds = (365 * 24 * 60 * 60 * 1e3) // 1y
      }

      if (seconds == null) {
        seconds = (24 * 60 * 60 * 1e3) // 24h
      }

      var expiresAt = new Date()
      seconds = expiresAt.getSeconds() + seconds
      expiresAt.setSeconds(seconds)

      var obj = {
        key,
        value,
        expiresAt: expiresAt.getTime()
      }

      commit(KEYS.Set, obj)
    },

    get({ commit, getters }, key) {
      return getters.cache_get(key)
    },

    remove({ commit }, key) {
      if (key == null || key === '') {
        throw new Error('cache key is required')
      }

      commit(KEYS.Remove, key)
    },

    clear({ commit }, pattern) {
      if (pattern == null || pattern === '') {
        commit(KEYS.ClearAll)
        return
      }

      commit(KEYS.Clear, pattern)
    }
  },
  getters: {
    cache_items: state => {
      return state.cache_objects.filter(x => x.expiresAt >= now())
    },
    cache_expiredItems: state => {
      return state.cache_objects.filter(x => x.expiresAt < now())
    },
    cache_get: state => key => {
      if (key == null || key === '') {
        return
      }

      var obj = state.cache_objects.filter(x => x.key === key && x.expiresAt >= now())
      if (obj.length === 0) {
        return
      }

      return obj[0].value
    }
  }
}
